/**
 * Define globally useful constants here
 * import individually to other files
 */

export const
    $document = $(document),
    $window = $(window),
    $body = $('body');